import { render, staticRenderFns } from "./SellerReAuth.vue?vue&type=template&id=edb37a42&scoped=true"
import script from "./SellerReAuth.vue?vue&type=script&lang=js"
export * from "./SellerReAuth.vue?vue&type=script&lang=js"
import style0 from "./SellerReAuth.vue?vue&type=style&index=0&id=edb37a42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb37a42",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSpinner,QIcon,QBtn,QBanner});
